import "./ChessRegistrationDetailsComponent.scss";
import template from "./ChessRegistrationDetailsComponent.html";
import {IComponentOptions} from "angular";
import {Observable, ReplaySubject} from "rxjs";
import {ChessRegistrationDetailRecord, ChessRegistrationDetailRecords} from "../../types/ChessRegistrationDetailRecord";
import {ChessRegistrationDetailsService} from "../../services/ChessRegistrationDetailsService";
import {AccountId} from "../../types/AccountRecord";

export const ChessRegistrationDetail = "tfChessRegistrationDetail";

export function chessRegistrationDetail(): IComponentOptions {
    return {
        template,
        bindings: {
            accountId: "<",
        },
        controllerAs: "ctrl",
        controller: ChessRegistrationDetailsComponent
    };
}

export class ChessRegistrationDetailsComponent {

    /** @input */
    public set accountId(accountId: AccountId | null) {
        if (accountId != null) {
            this.accountId$.next(accountId);
        }
    }
    private readonly accountId$ = new ReplaySubject<AccountId>(1);
    public viewHin = false;
    public readonly name1$: Observable<string | null>;
    public readonly name2$: Observable<string | null>;
    public readonly name3$: Observable<string | null>;
    public readonly designation$: Observable<string | null>;
    public readonly addressLine1$: Observable<string | null>;
    public readonly addressLine2$: Observable<string | null>;
    public readonly addressLine3$: Observable<string | null>;
    public readonly addressLine4$: Observable<string | null>;
    public readonly postCode$: Observable<string | null>;
    public readonly countryCode$: Observable<string | null>;
    public readonly hin$: Observable<string | null>;
    private readonly chessRegistrationDetails$: Observable<ChessRegistrationDetailRecord>;

    /** @ngInject */
    public constructor(private readonly chessRegistrationDetailsService: ChessRegistrationDetailsService) {
        this.chessRegistrationDetails$ = this.accountId$
                                             .map((account) => account)
                                             .switchMap((account) => this.retrieveChessRegistrationDetails(account))
                                             .map((details) => details[0])
                                             .publishReplay(1)
                                             .refCount();

        this.name1$ = this.chessRegistrationDetails$
                          .map((detail) => detail.name1);

        this.name2$ = this.chessRegistrationDetails$
                          .map((detail) => detail.name2);

        this.name3$ = this.chessRegistrationDetails$
                          .map((detail) => detail.name3);

        this.designation$ = this.chessRegistrationDetails$
                                .map((detail) => detail.designation);

        this.addressLine1$ = this.chessRegistrationDetails$
                                 .map((detail) => detail.addressLine1);

        this.addressLine2$ = this.chessRegistrationDetails$
                                 .map((detail) => detail.addressLine2);

        this.addressLine3$ = this.chessRegistrationDetails$
                                 .map((detail) => detail.addressLine3);

        this.addressLine4$ = this.chessRegistrationDetails$
                                 .map((detail) => detail.addressLine4);

        this.postCode$ = this.chessRegistrationDetails$
                             .map((detail) => detail.postCode);

        this.countryCode$ = this.chessRegistrationDetails$
                                .map((detail) => detail.countryCode);

        this.hin$ = this.chessRegistrationDetails$
                        .map((detail) => detail.hin);
    }

    public toggleHin() {
        this.viewHin = !this.viewHin;
    }

    private retrieveChessRegistrationDetails(accountId: AccountId): Observable<ChessRegistrationDetailRecords> {
        return Observable.of(accountId)
                         .flatMap((i) => this.chessRegistrationDetailsService.detail(accountId))
                         .catch((err) => Observable.empty());
    }
}
